import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import EmailIndex from './EmailIndex';
import UserIndex from './UserIndex';
import UserFormUpdate from './UserFormUpdate';

const ModalIndex = (props) => {
    const [currentTab, setCurrentTab] = useState("email");
    const [user, setUser] = useState({});

    const toogleTab = (current_tab) => {
        setCurrentTab(current_tab)
    }

    const toogleSetUser = (user) => {
        setUser(user)
    }
    
    return (
        <React.Fragment>
            <Modal isOpen={props.modal} toggle={props.toggle} className="modal-dialog-centered" backdrop={props.backdrop}>
                <ModalBody>
                    {currentTab == "email" && (
                        <EmailIndex
                            toogleTab={toogleTab}
                            toogleSetUser={toogleSetUser}
                            toggle={props.toggle}
                        />
                    )}

                    {currentTab == "user" && (
                        <UserIndex
                            user={user}
                            toogleTab={toogleTab}
                        />
                    )}

                    {currentTab == "user_form_update" && (
                        <UserFormUpdate
                            user={user}
                            toogleTab={toogleTab}
                            toggle={props.toggle}
                        />
                    )}
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
}


export default ModalIndex;

